import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// CSS
import "../../css/featured-products.css";

// State
import { getFeaturedProducts } from "../../store/actions/siteInfo";
import { REACT_APP_RESOURCE_URL } from '../../shared/vars'

class FeaturedProducts extends Component {

    componentDidMount(){
        this.props.getFeaturedProducts();
    }

	render() {
        const {featuredProducts} = this.props;

		return (
			<div className="body_container fp-home">
                {!!featuredProducts && featuredProducts.length ?
                <div className="fp-home-products">
                    <div className="fp-home-head">
                        <div><span>Featured</span><br/>products</div>
                        <div className="fp-home-head-line"></div>
                    </div>
                    {!!featuredProducts && 
                        featuredProducts.map((item, index) => {
                            return (
                                <Link className="fp-home-products-item" key={index} to={'/' + item.category_permalink + '/product/' + item.permalink}>
                                    <div><img src={REACT_APP_RESOURCE_URL + 'images/products/1/' + item.src} alt={item.title}></img></div>
                                    <div className="fp-home-products-item-title">{item.title}</div>
                                </Link>
                            )
                        })
                    }
                </div>
                : <div></div>
                }
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		featuredProducts: state.siteInfo.featured
	}
}

export default connect(mapStateToProps, { getFeaturedProducts })(FeaturedProducts)



// WEBPACK FOOTER //
// ./src/components/home/FeaturedProducts.js